import { render } from "./HorizontalProductScroll.vue?vue&type=template&id=0d93bbc8"
import script from "./HorizontalProductScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalProductScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__